import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const FavouritesWidgetLoader: LoaderFnConfig = {
    id: 'favourites-widget',
    loaderFn: () => import('./favourites-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
